<template>
    <div id="accommoidation-consideration">
        <v-card-subtitle class="font-weight-bold pb-0">
            <v-icon :color="subAppColor" left>mdi-hand-heart</v-icon> Accommodation Consideration(s)
        </v-card-subtitle>
        <v-card-text>
            <v-container fluid>
                <v-row>
                    <v-col cols="12">
                        <v-text-field v-model="item.specialAccommodationBasis" readonly
                            label="Special Accommodation Basis" placeholder="Not specified">
                        </v-text-field>
                    </v-col>
                    <v-col cols="12">
                        <v-textarea v-model="item.specialAccommodationConsideration" auto-grow readonly
                            label="Special Accommodation Consideration" outlined placeholder="Not specified">
                        </v-textarea>
                    </v-col>
                    <v-col cols="12">
                        <v-textarea v-model="item.specialAccommodationDescription" auto-grow readonly hide-details
                            label="Special Accommodation Description" outlined placeholder="Not specified">
                        </v-textarea>
                    </v-col>
                    <v-col cols="12" v-if="showSuperSingleRequestView == false">
                        <v-text-field v-model="item.singleRoomRequestReason" readonly
                            label="Single Room Request Reason" placeholder="Not specified">
                        </v-text-field>
                    </v-col>
                    <v-col cols="12" v-if="showSuperSingleRequestView == true && showSingleRoomRequest() == true">
                        <v-checkbox v-model="item.requestSuperSingle" hide-details true-value="yes" false-value="no" label="I am requesting a Super Single" readonly></v-checkbox>
                    </v-col>
                    <v-col cols="12" v-if="showSuperSingleRequestView == true && showSingleRoomRequest() == true">
                        <v-checkbox v-model="item.requestSingleRoom" true-value="yes" false-value="no" label="I am requesting a Single Room" readonly></v-checkbox>
                    </v-col>
                    <v-col cols="12"> </v-col>
                    <v-col cols="12">
                        <v-textarea v-model="item.singleRoomRequestAdditionalInformation" auto-grow readonly hide-details
                            label="Special Room Request Additional Information" outlined placeholder="Not specified">
                        </v-textarea>
                    </v-col>
                    <v-col cols="12">
                        <v-textarea v-model="item.singleRoomRequestAdditionalInformation" auto-grow readonly hide-details
                            label="Special Room Request Additional Information" outlined placeholder="Not specified">
                        </v-textarea>
                    </v-col>
                </v-row>
            </v-container>
        </v-card-text>
    </div>
</template>

<script>
export default {
    name: 'applicant-accommodation-consideration',
    props: {
        item: {
            required: true,
            type: Object
        }
    },
    computed: {
        subAppColor() {
            return '#FFA800';
        }
    },
    data(){
        return {
            showSuperSingleRequestView: true
        }
    },
    methods: {
        checkSubmissionDate(){
            const that = this;

            let createdTimestamp = that.item.createdTimestamp;
            let cutoffDate = 0;

            //Update Nov 7, 2025
            //If submitted before Nov 14 00:00 AM (1763078401), show older Single Room request, else show the new Single Room / Super Single request view (production)
            if(location.hostname == 'mykings.ca'){
                cutoffDate = 1763078401 //2025 Nov 14 00:00:01
            }else {
                cutoffDate = 1762524000 //2025 Nov 07 14:00:00
            }

            if(parseInt(createdTimestamp) < parseInt(cutoffDate)){
                that.showSuperSingleRequestView = false;
            }else {
                that.showSuperSingleRequestView = true;
            }
            
        },
        showSingleRoomRequest(){

            let buildingOption1Check = /Epworth Place/i.test(this.item.buildingOption01) || /King's Commons/i.test(this.item.buildingOption01);
            let buildingOption2Check = /Epworth Place/i.test(this.item.buildingOption02) || /King's Commons/i.test(this.item.buildingOption02);
            let upperyear = ["2", "3", "4"]
            let yearofStudyCheck = upperyear.includes(this.item.yearOfStudy)

            if(yearofStudyCheck && (buildingOption1Check || buildingOption2Check)){
                return false
            }

            return true

        } 
    },
    beforeUpdate(){
        this.checkSubmissionDate();
    }
}
</script>